export const GAMES_VIEW_RESET_STORAGE_PATH = 'GAMES_VIEW_RESET_STORAGE_PATH';
export const GAMES_VIEW_SET_ACTIVE_STORAGE = 'GAMES_VIEW_SET_ACTIVE_STORAGE';
